module.exports = __webpack_public_path__ + "static/media/f_eyebrowshape_rounded.a044ecbd.png";